<mat-form-field [class.readonly]="readonly" appearance="outline" class="tag-form-field">
  <mat-label>Tags</mat-label>

  <mat-chip-grid #chipList aria-label="Task Tags">
    @for (tag of tags; track tag) {
      <mat-chip-row (removed)="removeTag(tag)" class="task-tag">
        {{ tag }}

        @if (!readonly) {
          <button matChipRemove [attr.aria-label]="'remove ' + tag">
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
    }

    <input
      placeholder="Type and press Enter or blur to add tag..."
      #tagInput
      [readonly]="readonly"
      [formControl]="tagInputControl"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="[13]"
      (matChipInputTokenEnd)="addTag($event)"
      (blur)="onTouched()" />
  </mat-chip-grid>
</mat-form-field>
